<template>
	<!-- 渠道合作 -->
	<div class="channel share_center">
		<div class="seat">
			<div class="about_hedaer ">
				<div class="logo_box">
					<div class="logo"></div>
					<div class="qw_logo"></div>
				</div>
				<div class="header_list">
					<ul>
						<li :style="listTitleIndex==index?'color:#FF6600;':''" v-for="(item,index) in listTitle" :key='index' @click="go(item.url)">
							{{item.title}}
						</li>
					</ul>
				</div>
				<div class="header_rig">
					<div class="btn " @click="open">预约演示</div>
					<!-- <div class="btn btn2" @click="open">登录/注册</div> -->
				</div>
			</div>
		</div>
		<!-- 移动端样式 -->
		<option-header class="seat2"></option-header> 
		<!-- 移动端样式 end-->
		<div class="banner" >
			<div class='modular' @click="open()"></div>
		</div>
		<div class="choice_my share_Up_down">
			<div class="card_box">
				<ul class="share_list_center animate__animated animate__fadeInUp">
					<li v-for="(item,index) in list" :key='index'>
						<div class="pic">
							<img :src="item.pic" >
						</div>
						<div class="right">
							{{item.title}}
							<p>
								<countTo class="count" :startVal='startVal' :endVal='Number(item.num)' :duration='duration'></countTo>
								+
								<span>{{item.company}}</span>
							</p>
						</div>
					</li>
				</ul>
			</div>
			<div class="content">
				<div class="title share_Up_down-center animate__animated animate__fadeInUp">
					为什么要选择我们
					<span>四大项目优势为你保驾护航</span>
				</div>
				<div class="content_list" ref="contentList" >
					<ul class="share_list_center animate__animated animate__fadeInUp">
						<li v-for="(item,index) in contentList" :key='index'>
							<div class="li_title share_transverse_center">
								<div class="pic">
									<img :src="item.pic" >
								</div>
								<div class="text">{{item.title}}</div>
							</div>
							<div class="text_box">
								<!-- 1 -->
								<p v-for="(itemson,indexson) in item.list" :key='indexson'>
									{{indexson+1}}. 
									<span>{{itemson}}</span> 
								</p>
							</div>
						</li>
					</ul>
				</div>
				<div ref="channelPolicyTit" >
					<div v-show="channelPolicyTitShow" class="title title2 share_Up_down-center animate__animated animate__fadeInUp">
						渠道全流程扶持政策
						<span>为用户服务，为伙伴赋能</span>
					</div>
				</div>
				
			</div>
		</div>
		<!-- 渠道全流程扶持政策 -->
		<div class="policy share_center" ref='policyList'>
			<div class="wrap" >
				<ul v-show="policyListShow" class="share_between_wrap animate__animated animate__fadeInUp">
					<li class="share_Up_down" v-for="(item,index) in policyList" :key='index'>
						<div class="pic">
							<img :src="item.pic" alt="">
						</div>
						<div class="text_box share_Up_down">
							<span v-for="(itemson,indexson) in item.list" :key='indexson'>{{itemson}}</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<!-- 渠道合作流程 -->
		<div class="process share_Up_down" ref="process"  >
			<div v-show="processShow" class="title share_Up_down-center animate__animated animate__fadeInUp">
				渠道合作流程
				<span>为用户服务，为伙伴赋能 </span>
			</div>
			<div class="process_pic" ref="processPic" >
				<img v-show="processPicShow" class="animate__animated animate__fadeInUp" src="../../../public/images/channel-3-1.png" >
			</div>
			<!-- 移动端样式 -->
			<div class="process_pic2" ref="processPic" >
				<img v-show="processPicShow" class="animate__animated animate__fadeInUp" src="../../../public/images/phonebj7.png" >
			</div>
			<!-- 移动端样式 end-->
		</div>
		<!-- 全国覆盖区域 -->
		<div class="country share_Up_down" ref="country"  >
			<div v-show="countryShow" class="title share_Up_down-center animate__animated animate__fadeInUp">
				全国覆盖区域
				<span>2022年将覆盖500个县市区域 </span>
			</div>
			<div class="box" ref="countryBox"  >
				<div v-show="countryBoxShow" class="rightBox animate__animated animate__fadeInUp">
					<div class="right_top">截止目前，全国实现{{list[2].num}}+县市覆盖，已服务{{list[1].num}}+门店，{{consumer}}+客户</div>
					<!-- <div class="right_cet">已服务{{list[1].num}}+门店，{{consumer}}+客户</div> -->
					<div class="right_btm">2022年将实现全国500+县市 <span>覆盖 服务门店3000+ 服务客户300000+</span></div>
				</div>
				<div v-show="countryBoxShow" class="leftBox">
					<div class="pic animate__animated animate__fadeInUp">
						<img src="../../../public/images/channel-3-2.png" >
					</div>
				</div>
				
			</div>
		</div>
		<brand-box></brand-box>
		<my-footer></my-footer>
		<register v-show="registerShow" @change='open'></register>
	</div>
</template>

<script>
	import register from '@/components/register/index.vue'
	import brandBox from '@/components/brandBox/index.vue'
	import myFooter from '@/components/myFooter/index.vue'
	import optionHeader from '@/components/optionHeader/index.vue'
	import countTo from 'vue-count-to';
	import { indexRecord } from '@/api'
	export default{
		components:{
			brandBox,
			myFooter,
			register,
			optionHeader,
			countTo
		},
		data() {
			return{
				registerShow:false,
				listTitle:[{
						title:'首页',
						url:'/home',
					},{
						title:'产品服务',
						url:'/product',
					},{
						title:'渠道合作',
						url:'',
					},{
						title:'关于我们',
						url:'/aboutUs',
					},
				],
				listTitleIndex:'2',
				startVal:0,
				duration:5000,															//时间
				list:[
					{
						pic:require('../../../public/images/channel-1.png'),
						title:'服务品牌',
						num:'',
						company:'个'
					},{
						pic:require('../../../public/images/channel-2.png'),
						title:'服务门店',
						num:'',
						company:'个'
					},{
						pic:require('../../../public/images/channel-3.png'),
						title:'覆盖城市',
						num:'',
						company:'个'
					}
				],
				consumer:0,
				contentList:[
					{
						pic:require('../../../public/images/channel-1-1.png'),
						title:'产品优势',
						list:[
							'MarTech+SCRM的一站式营销 云软件解决方案',
							'独立研发并服务上万商户的基 于微信私域流量的裂变系统',
							'针对汽服行业强大的数据分析 能力及用户标签画像体系 ， 横 向帮商户的做经营决策 ， 纵向 帮商户做深度用户运营',
							'国内知名车辆管理系统的全端 接口数据整合'
						]
					},{
						pic:require('../../../public/images/channel-1-2.png'),
						title:'资源优势',
						list:[
							'全国汽服行业百强连锁品牌推 荐的微信私域合作运营商  ',
							'当地媒体大V、分销达人、车友 会的联合流量补给 ',
							'腾讯企业微信优质服务商的政 策及全端接口技术支持 ',
							'中国区域汽服行业网络联盟协会'
						]
					},{
						pic:require('../../../public/images/channel-1-3.png'),
						title:'运营优势',
						list:[
							' 制定获客和利润转化的专属方案',
							'线上线下一站式的营销落地能力',
							'赋能商家的完善培训体系',
							'1V1运营专家全程提供运营指导',
							'7*24小时客服实时疑问解答 ',
							'团队对活动复盘后输出商家经营 改善意见'
						]
					},{
						pic:require('../../../public/images/channel-1-4.png'),
						title:'经验优势',
						list:[
							'十年专注服务于上万本地生活 商家的成熟的运营体系及产品 解决方案 ',
							'三年内全国上百场大型车主福 利节日及商户营销活动的得失 问题复盘总结及数据分析 ',
							'国内上亿用户年百亿规模的大 平台运作模式的操盘及管理经 验 ',
						]
					}
				],
				policyList:[
					{
						pic:require('../../../public/images/channel-2-1.png'),
						list:['TOP级','行业产品保障']
					},{
						pic:require('../../../public/images/channel-2-2.png'),
						list:['客户成功行业','解决方案加持']
					},{
						pic:require('../../../public/images/channel-2-3.png'),
						list:['营销素材','全覆盖']
					},{
						pic:require('../../../public/images/channel-2-4.png'),
						list:['营销系统 ','支持']
					},{
						pic:require('../../../public/images/channel-2-5.png'),
						list:['运营支持']
					},{
						pic:require('../../../public/images/channel-2-6.png'),
						list:['培训支持']
					},{
						pic:require('../../../public/images/channel-2-7.png'),
						list:['专业服务团队']
					},{
						pic:require('../../../public/images/channel-2-8.png'),
						list:['品牌支持']
					}
				],
				contentListShow:false,
				channelPolicyTitShow:false,
				policyListShow:false,
				processShow:false,
				processPicShow:false,
				countryShow:false,
				countryBoxShow:false,
			}
		},
		mounted() {
			this.getIndexRecord()
			window.addEventListener("scroll", this.handleScroll);
			window.addEventListener("scroll", this.handle);
		},
		methods:{
			// 获取数据展示
			getIndexRecord(){
				indexRecord().then(res => {
					if(res.code == 200){
						this.list[0].num = res.data.info.brand 		//服务品牌
						this.list[1].num = res.data.info.store 		//服务门店
						this.list[2].num = res.data.info.city		//覆盖全国城市
						this.consumer = res.data.info.consumer		//客户数
					}else{
						console.log(res.msg)
					}
				})
			},
			// 
			open(){
				this.registerShow = !this.registerShow
			},
			
			go(url){
				if(url != ''){
					document.documentElement.scrollTop = 0
					this.$router.push(url)
				}
				
			},
			handleScroll () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'contentList', show: 'contentListShow'},
					{ref: 'channelPolicyTit', show: 'channelPolicyTitShow'},
					{ref: 'policyList', show: 'policyListShow'},
					{ref: 'process', show: 'processShow'},
					{ref: 'processPic', show: 'processPicShow'},
					{ref: 'country', show: 'countryShow'},
					{ref: 'countryBox', show: 'countryBoxShow'},
			      ]
				  // console.log(refArray)
				refArray.forEach((r,i) => {
					_this.gdjz(r.ref, 20, () => {
						_this[r.show] = true
					})
				})
			},
			gdjz(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c > a ) {
						callback && callback()
					}
				}
			},
			handle () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'contentList', show: 'contentListShow'},
					{ref: 'channelPolicyTit', show: 'channelPolicyTitShow'},
					{ref: 'policyList', show: 'policyListShow'},
					{ref: 'process', show: 'processShow'},
					{ref: 'processPic', show: 'processPicShow'},
					{ref: 'country', show: 'countryShow'},
					{ref: 'countryBox', show: 'countryBoxShow'},
			      ]
				refArray.forEach((r,i) => {
					_this.gd(r.ref, 20, () => {
						_this[r.show] = false
					})
				})
			},
			gd(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c < a ) {
						callback && callback()
					}
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@media (max-width:1487px){
		.choice_my{
			width: 100%;
			min-height:9.78rem ;
			background-color: #fff;
			
			.content{
				width: 12rem;
				// background-color: #0000FE;
				margin-top: 0.42rem;
				padding-bottom: 0.6rem;
				.title{
					font-size: 0.28rem;
					color: #000000;
					span{
						font-size: 0.18rem;
						color: #999999;
						margin-top: 0.18rem;
					}
				}
				.title2{
					margin-top: 1.25rem;
				}
				.content_list{
					width: 12rem;
					// height: 3.9rem;
					margin-top: 0.85rem;
					
					ul{
						width: 12rem;
						min-height: 4.2rem;
						flex-wrap: wrap;
						
						li{
							width: 2.7rem;
							min-height: 4.2rem;
							background: #FFFFFF;
							box-shadow: 0rem 0rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
							border-radius: 0.2rem;
							display: flex;
							flex-direction: column;
							align-items: center;
							.li_title{
								font-size: 0.2rem;
								margin-top: 0.18rem;
								.pic{
									width: 0.26rem;
									height: 0.26rem;
									margin-right: 0.17rem;
									
									img{
										width: 0.26rem;
										height: 0.26rem;
									}
								}
							}
							p{
								font-size: 0.18rem;
								width: 2.4rem;
								color: #8C8B8B;
								display: flex;
								// justify-content: space-between;
								line-height: 0.24rem;
								margin-top: 0.23rem;
								span{
									margin-left: 0.1rem;
									font-size: 0.18rem;
								}
							}
						}
						li:hover{
							width: 4.7rem;
							min-height: 4.9rem;
							background: #FFFFFF;
							box-shadow: 0rem 0rem 0.24rem 0px rgba(51, 51, 51, 0.2);
							border-radius: 0.2rem;
						}
					}
				}
			}
		}
	}
	.channel{
		width: 100%;
		.seat{
			width: 100%;
			height: 0.6rem;
			display: flex;
			justify-content: center;
			position: -webkit-sticky;
			position: sticky;
			top: 0;
			background-color: #fff;
			z-index: 111;
		}
		.seat2{
			display: none;
		}
		.about_hedaer{
			width: 12rem;
			height: 0.6rem;
			display: flex;
			align-items: center;
			.logo_box{
				width: 23.41%;
				height: 0.39rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 0.16rem;
				
				.logo{
					width:52.5%;
					height: 0.39rem;
					background: url(../../../public/images/logo.png) no-repeat center center;
					background-size: 1.31rem 0.39rem;
				}
				.qw_logo{
					width: 44%;
					height: 0.25rem;
					background: url(../../../public/images/qwlogo.png) no-repeat center center;
					background-size: 1.21rem 0.25rem;
				}
			}
			.header_list{
				width: 37%;
				// margin-top: 0.12rem;
				margin-left:6.82%;
				
				ul{
					width: 100%;
					height: 0.16rem;
					display: flex;
					justify-content: space-between;
					li{
						height: 0.16rem;
						font-size: 0.16rem;
						
					}
					li:hover{
						color: #FF7300;
					}
				}
				
			}
			.header_rig{
				width: 2rem;
				height: 0.3rem;
				margin-top: 0.04rem;
				margin-left: 7.45%;
				// display: flex;
				// justify-content: space-between;
				
				.btn{
					width: 0.9rem;
					height: 0.3rem;
					border: 0.01rem solid #FF9729;
					border-radius: 0.1rem;
					font-size: 0.12rem;
					text-align: center;
					line-height: 0.3rem;
					float: right;
				}
				.btn2{
					background: #FF9729;
					border-radius: 0.1rem;
					color: #fff;
				}
			}
		}
		// 背景图
		.banner{
			width: 100%;
			height: 5rem;
			background: url(../../../public/images/channelBanner.jpg) no-repeat center center;
			background-size: 100% 5rem;
			position: relative;
			.modular{
				width: 210px;
				height: 60px;
				// background: #ffffff;
				position: absolute;
				top: 2.9rem;
				left: 3.5rem;
				z-index: 9;
			}
		}
		.choice_my{
			width: 100%;
			min-height:9.78rem ;
			background-color: #fff;
			.card_box{
				width: 12rem;
				height: 1.5rem;
				ul{
					width: 12rem;
					height: 1.5rem;
					margin-top: -0.45rem;
					li{
						width: 3.6rem;
						height: 1.5rem;
						background: #FFFDFB;
						box-shadow: 0rem 0.13rem 0.24rem 0rem rgba(244, 244, 244, 0.82);
						border-radius: 0.2rem;
						display: flex;
						
						.pic{
							width: 0.63rem;
							height: 0.59rem;
							margin-top: 0.2rem;
							margin-left: 0.78rem;
							img{
								width: 0.63rem;
								height: 0.59rem;
							}
						}
						.right{
							height: 0.7rem;
							font-size: 0.14rem;
							color: #565656;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							margin-top: 0.42rem;
							margin-left: 0.23rem;
							
							p{
								font-size: 0.38rem;
								color: #FF7300;
								.count{
									font-size: 0.38rem;
									color: #FF7300;
								}
								span{
									font-size: 14px;
									color: #565656;
								}
							}
						}
					}
				}
			}
			.content{
				width: 12rem;
				// background-color: #0000FE;
				margin-top: 0.42rem;
				padding-bottom: 0.6rem;
				.title{
					font-size: 0.28rem;
					color: #000000;
					span{
						font-size: 0.18rem;
						color: #999999;
						margin-top: 0.18rem;
					}
				}
				.title2{
					margin-top: 1.25rem;
				}
				.content_list{
					width: 12rem;
					// height: 3.9rem;
					margin-top: 0.85rem;
					
					ul{
						width: 12rem;
						// height: 3.9rem;
						flex-wrap: wrap;
						
						li{
							width: 2.7rem;
							height: 4.2rem;
							background: #FFFFFF;
							box-shadow: 0rem 0rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
							border-radius: 0.2rem;
							display: flex;
							flex-direction: column;
							align-items: center;
							padding-bottom: 0.18rem;
							.li_title{
								font-size: 0.2rem;
								margin-top: 0.18rem;
								.pic{
									width: 0.26rem;
									height: 0.26rem;
									margin-right: 0.17rem;
									
									img{
										width: 0.26rem;
										height: 0.26rem;
									}
								}
							}
							p{
								font-size: 0.16rem;
								width: 2.4rem;
								color: #8C8B8B;
								display: flex;
								// justify-content: space-between;
								line-height: 0.24rem;
								margin-top: 0.23rem;
								span{
									margin-left: 0.1rem;
									font-size: 0.16rem;
								}
							}
						}
						li:hover{
							width: 2.7rem;
							min-height: 3.9rem;
							background: #FFFFFF;
							box-shadow: 0rem 0rem 0.24rem 0px rgba(51, 51, 51, 0.2);
							border-radius: 0.2rem;
							padding-bottom: 0.18rem;
						}
					}
				}
			}
		
		}
		.policy{
			width: 100%;
			height: 8.01rem;
			background: url(../../../public/images/bj9.png)no-repeat center center;
			background-size: 100% 8.01rem;
			
			.wrap{
				width: 12rem;
				ul{
					width: 12rem;
					height:6.36rem;
					li{
						width: 2.7rem;
						height: 3rem;
						background: rgba(255, 255, 255, 0.7);
						box-shadow: 0rem 0rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
						border-radius: 0.2rem;
						
						.pic{
							width: 0.57rem;
							height: 0.58rem;
							margin-top: 0.62rem;
							margin-bottom: 0.29rem;
							display: flex;
							img{
								width: 0.57rem;
								height: 0.58rem;
							}
						}
						.text_box{
							font-size: 0.22rem;
							color: #010101;
							height: 0.57rem;
							
							span{
								margin-bottom: 0.1rem;
								font-size: 0.24rem;
							}
						}
					}
				}
			}
		}
		.process{
			width: 100%;
			height: 5.4rem;
			background-color: #fff;
			margin-bottom: 100px;
			.title{
				font-size: 0.28rem;
				color: #000000;
				margin-top: 1.18rem;
				margin-bottom: 0.7rem;
				span{
					font-size: 0.18rem;
					color: #999999;
					margin-top: 0.18rem;
				}
			}
			
			.process_pic{
				width: 12rem;
				height: 1.66rem;
				img{
					width: 12rem;
					height: 1.66rem;
				}
			}
			.process_pic2{
				display: none;
			}
		}
		.country{
			width: 100%;
			height: 12.8rem;
			// margin-bottom: 0.6rem;
			background: #F9F9F9;
			.title{
				font-size: 0.32rem;
				color: #000000;
				margin-top: 0.61rem;
				margin-bottom: 0.7rem;
				span{
					font-size: 0.18rem;
					color: #999999;
					margin-top: 0.18rem;
				}
			}
			.box{
				width: 13rem;
				// height:5.5rem;
				// display: flex;
				.leftBox{
					width: 13rem;
					height: 7.1rem;
					text-align: center;
					margin-top: 36px;
					.pic{
						
						margin: 0 outo;
						// background-color: #0000FF;
						img{
							width: 12rem;
							height: 8.5rem;
						}
					}
				}
				.rightBox{
					font-size: 0.28rem;
					color: #333333;
					text-align: center;
					.right_top{
						text-align: center;
						font-size: 0.28rem;
					}
					.right_cet{
						
					}
					.right_btm{
						font-size: 0.18rem;
						color: #999999;
						line-height: 0.25rem;
						text-align: center;
						margin-top: 0.35rem;
					}
				}
			}
		}
	}
	
	// 移动端样式
	@media (max-width:1026px){
		.channel{
			width: 100%;
			.seat{
				display: none;
			}
			.seat2{
				display: block;
			}
			
			// 背景图
			.banner{
				width: 100%;
				height: 2.9rem;
				background: url(../../../public/images/channelBanner.jpg) no-repeat center center;
				background-size: 100% 2.9rem;
				.modular{
					width: 2.1rem;
					height: 0.6rem;
					// background: #ffffff;
					position: absolute;
					top: 1.6rem;
					left: 1.6rem;
					z-index: 9;
				}
			}
			.choice_my{
				width: 100%;
				min-height:9.78rem ;
				background-color: #fff;
				.card_box{
					width: 6.9rem;
					height: 1.5rem;
					ul{
						width: 6.9rem;
						height: 1.5rem;
						margin-top: -0.2rem;
						li{
							width: 2.2rem;
							height: 1.2rem;
							background: #FFFDFB;
							box-shadow: 0rem 0.13rem 0.24rem 0rem rgba(244, 244, 244, 0.82);
							border-radius: 0.2rem;
							display: flex;
							
							.pic{
								width: 0.56rem;
								height: 0.52rem;
								margin-top: 0rem;
								margin-left: 0.24rem;
								img{
									width: 0.56rem;
									height: 0.52rem;
								}
							}
							.right{
								height: 0.7rem;
								font-size: 0.18rem;
								color: #565656;
								display: flex;
								flex-direction: column;
								justify-content: space-between;
								margin-top: 0.25rem;
								margin-left: 0.17rem;
								
								p{
									font-size: 0.32rem;
									color: #FF7300;
									
									span{
										font-size: 14px;
										color: #565656;
									}
								}
							}
						}
					}
				}
				.content{
					width: 6.9rem;
					// background-color: #0000FE;
					margin-top: 0.29rem;
					padding-bottom: 0.6rem;
					.title{
						font-size: 0.32rem;
						color: #000000;
						span{
							font-size: 0.24rem;
							color: #999999;
							margin-top: 0.18rem !important;
						}
					}
					.title2{
						margin-top: 0.18rem;
					}
					.content_list{
						width: 6.9rem;
						margin-top: 0.85rem;
						
						ul{
							width: 6.9rem;
							flex-wrap: wrap;
							padding-bottom: 0.29rem;
							
							li{
								width: 6.9rem;
								min-height:1rem !important;
								background: #FFFFFF;
								box-shadow: 0rem 0rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
								border-radius: 0.2rem;
								display: flex;
								flex-direction: column;
								align-items: flex-start;
								padding-bottom: 0.29rem;
								margin-bottom: 0.2rem;
								.li_title{
									height: 0.34rem;
									text-align: left;
									font-size: 0.28rem;
									margin-top: 0.29rem;
									margin-left: 0.33rem;
									.pic{
										width: 0.31rem;
										height: 0.34rem;
										margin-right: 0.17rem;
										
										img{
											width: 0.31rem;
											height: 0.34rem;
										}
									}
								}
								.text_box{
									width: 6.59rem;
									p{
										margin-left: 0.33rem;
										font-size: 0.24rem;
										width: 6.2rem;
										color: #8C8B8B;
										display: flex;
										line-height: 0.3rem;
										margin-top: 0.29rem;
										span{
											// width: 5.9rem;
											margin-left: 0.1rem;
											font-size: 0.24rem;
											
										}
									}
								}
								
							}
							li:hover{
								width: 6.9rem;
								min-height:1rem !important;
								background: #FFFFFF;
								box-shadow: 0rem 0rem 0.24rem 0rem rgba(51, 51, 51, 0.05);
								border-radius: 0.2rem;
								padding-bottom: 0.29rem;
							}
						}
					}
				}
			
			}
			.policy{
				width: 100%;
				height: 8.01rem;
				background: url(../../../public/images/bj9.png)no-repeat center center;
				background-size: 100% 8.01rem;
				
				.wrap{
					width: 6.9rem;
					ul{
						width: 6.9rem;
						height:6.36rem;
						li{
							width: 3.4rem;
							height: 1.6rem;
							background: #FFFDFB;
							box-shadow: 0px 0.13rem 0.24rem 0px rgba(244, 244, 244, 0.82);
							border-radius: 0.3rem;
							display: flex;
							flex-direction: row;
							align-items: center;
							margin-bottom: 0.1rem;
							
							.pic{
								width: 0.59rem;
								height: 0.58rem;
								margin-top: 0rem;
								margin-left: 0.43rem;
								margin-bottom: 0rem;
								display: flex;
								img{
									width: 0.59rem;
									height: 0.58rem;
								}
							}
							.text_box{
								font-size: 0.26rem;
								color: #010101;
								height: 0.57rem;
								margin-left: 0.4rem;
								
								span{
									margin-bottom: 0.1rem;
								}
							}
						}
					}
				}
			}
			.process{
				width: 100%;
				height: 6rem;
				background-color: #fff;
				.title{
					font-size: 0.32rem;
					color: #000000;
					margin-top: 0.6rem;
					margin-bottom: 0.7rem;
					span{
						font-size: 0.24rem;
						color: #999999;
						margin-top: 0.18rem;
					}
				}
				.process_pic{
					width: 12rem;
					height: 1.66rem;
					display: none;
					img{
						width: 12rem;
						height: 1.66rem;
					}
				}
				.process_pic2{
					width: 7.16rem;
					height: 3.89rem;
					display: block;
					img{
						width: 7.16rem;
						height: 3.89rem;
					}
				}
			}
			.country{
				width: 100%;
				height: 9.34rem;
				background: #fff;
				.title{
					font-size: 0.32rem;
					color: #000000;
					margin-top: 0.8rem;
					margin-bottom: 0.7rem;
					span{
						font-size: 0.24rem;
						color: #999999;
						margin-top: 0.18rem;
					}
				}
				.box{
					width: 6.9rem;
					height: 9.34rem;
					flex-direction: column;
					align-items: center;
					.leftBox{
						width: 5.25rem;
						height: 4rem;
						.pic{
							width: 6rem;
							height: 4rem;
							img{
								width: 6rem;
								height: 4rem;
							}
						}
					}
					.rightBox{
						height: 2.2rem;
						font-size: 0.28rem;
						color: #333333;
						margin-left: 0rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						.right_top{
							margin-top: 0.57rem;
							color: #000000;
						}
						.right_cet{
							margin-top: 0.26rem;
							margin-bottom: 0.36rem;
						}
						.right_btm{
							display: flex;
							flex-direction: column;
							align-items: center;
							font-size: 0.22rem;
							color: #999999;
							width: 4.2rem;
							line-height: 0.25rem;
							span{
								margin-top: 0.18rem;
							}
						}
					}
				}
			}
		}
	}
</style>
